<template>
  <!-- 联系我们 -->
  <div class="warrper">
    <div class="header">
      <img
        style="width: 100%; height: 100%"
        src="../assets/cp/lxwm.png"
        alt=""
      />
    </div>
    <el-backtop></el-backtop>
    <div class="content_ml">
      <span @click="tiaozhuan()">首页></span
      ><span style="color: black">联系我们</span>
    </div>
    <div
      class="content"
      style="background: #f7f8fb; width: 100%; margin-top: 20px"
    >
      <div class="bt" id="topAnchor">
        <span>联系方式</span>
        <p>CONTACT INFORMATION</p>
      </div>
      <div class="lxfs">
        <div class="lxfsCard" v-for="item in lxData">
          <img :src="item.img" alt="" />
          <p class="pcon">{{ item.name }}</p>
          <p>{{ item.content }}</p>
          <p style="margin-top: -20px" v-if="item.name == '工作时间'">
            {{ item.content1 }}
          </p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bt" id="topAnchor3">
        <span>加入我们</span>
        <p>RECRUITMENT POSITION</p>
        <div class="jrwm" style="text-align: left" v-html="zwhtml"></div>
      </div>
    </div>

    <div class="gswz" >
      <div class="bt">
        <span>公司位置</span>
        <p>COMPANY LOCATION</p>
      </div>
      <div class="dt">
        <el-amap
          vid="amapDemo"
          :center="center"
          :zoom="zoom"
          class="amap-demo"
          :events="events"
        >
          <el-amap-marker
            :position="marker.position"
            :events="marker.events"
            :visible="marker.visible"
            :draggable="marker.draggable"
          ></el-amap-marker>
        </el-amap>
      </div>
    </div>
    <LXWM id="topAnchor1"></LXWM>
  </div>
</template>
<script>
import WOW from "wowjs";
import { seljoinus, inswrite, insforum } from "@/api/patient.js";
import LXWM from "../components/ContactUs.vue";
export default {
  components: { LXWM },
  name: "",
  data() {
    return {
      comCurrentIndex: 0,
      zoom: 15,
      center: [116.598821,39.892327],
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      marker: {
        position: [116.598821,39.892327],
      },
      address: "",
      events: {
        click(e) {
          let { lng, lat } = e.lnglat;
          self.lng = lng;
          self.lat = lat;
          self.marker.position = [lng, lat];
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all",
          });
          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                self.address = result.regeocode.formattedAddress;
                self.$nextTick();
              }
            }
          });
        },
      },
      zwhtml: "",
      lxData: [
        {
          img: require("../assets/lx/组 46.png"),
          name: "地址",
          content: "北京市朝阳区双桥中路1号院6幢二层2132",
        },
        {
          img: require("../assets/lx/组 51.png"),
          name: "电话",
          content: "010-6290-6806",
        },
        {
          img: require("../assets/lx/组 49.png"),
          name: "移动电话",
          content: "157-1135-5741",
        },
        // {
        //   img: require("../assets/lx/邮箱 (2).png"),
        //   name: "邮箱",
        //   content: "wyjk2019@jkcjyz.com",
        // },
        {
          img: require("../assets/lx/时间 (2).png"),
          name: "工作时间",
          content: "9:00-12:00",
          content1: "13:00-18:00",
        },
      ],
    };
  },
  created() {
    this.getseljoinus();
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      if (to.params.lx == "联系方式") {
        setTimeout(() => {
          const TOP = document.getElementById("topAnchor");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 1000);
      }
      if (to.params.lx == "加入我们") {
        debugger;
        setTimeout(() => {
          const TOP = document.getElementById("topAnchor3");
          console.log(TOP);
          const y = TOP.offsetTop;

          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 1000);
      }
      if (to.params.lx == "留言板") {
        setTimeout(() => {
          const TOP = document.getElementById("topAnchor1");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 1000);
      }
    });
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
  },
  filters: {},
  methods: {
    getseljoinus() {
      seljoinus().then((res) => {
        this.zwhtml = res[0].joinus;
      });
    },
    tiaozhuan() {
      this.$router.push("/");
    },
  },

  watch: {
    "$store.state.tzzx": {
      deep: true, //深度监听设置为 true
      handler: function (newVal, oldVal) {
        if (newVal == "联系方式") {
          const TOP = document.getElementById("topAnchor");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        } else if (newVal == "加入我们") {
          const TOP = document.getElementById("topAnchor3");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        } else if (newVal == "留言板") {
          const TOP = document.getElementById("topAnchor1");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.yhpl {
  width: 60%;
  margin: auto;
  margin-top: 100px;
  .comment {
    .btn {
      margin-top: 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
.warrper {
  width: 100%;
  min-height: 800px;
  .content_ml {
    margin-top: 20px;
    margin-left: 20%;
    color: #d3d3d3;
  }
  .content_ml:hover {
    margin-top: 20px;
    margin-left: 20%;
    color: #d3d3d3;
    pointer-events: auto;
    cursor: pointer;
  }
  .header {
    width: 100%;
    height: 407px;
    // background-image: url(../assets/lx/lx.png);
    // background-size: 100%, 100%;
    // background-size: cover;
    // background-repeat: no-repeat;
  }
  .gswz {
    width: 100%;

    .dt {
      width: 1200px;
      height: 604px;
      margin: auto;
      // padding: 0 20px;
      border: 1px solid #999999;
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .content {
    width: 60%;
    margin: auto;
    .lxfs {
      display: flex;
      justify-content: center;
      align-items: center;
      .lxfsCard:hover {
        width: 211px;
        height: 289px;
        background: #ffffff;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
        border-radius: 6px;
        text-align: center;
      }
      .lxfsCard {
        margin-bottom: 100px;
        width: 211px;
        height: 289px;
        border-radius: 6px;
        text-align: center;
        img {
          margin-top: 30px;
        }
        .pcon {
          height: 20px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #262626;
          line-height: 28px;
        }
        p {
          margin: auto;
          margin-top: 20px;
          width: 144px;
          height: 45px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #262626;
          line-height: 28px;
        }
      }
    }
    .jrwm {
      padding: 20px;
      background: #ffffff;
      box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.21);
    }
    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>
